
  import { defineComponent } from "vue";
  import html2canvas from "html2canvas";
  import { mapState } from "vuex";
  
  export default defineComponent({
    name: "CanvasComponent",
    data() {
      return {
        i: 0,
        isimgEnd: false
      };
    },
    computed: {
      ...mapState(["userInfo", "myResult"])
    },
    watch: {
      isimgEnd(v) {
        //图片全部加载完成后生成图片
        if (v) this.getPic();
      }
    },
    methods: {
      imgLoad(e) {
        this.i++;
        if (this.i == 4) this.isimgEnd = true;
      },
      getPic() {
        window.scrollTo(0, 0);
        setTimeout(() => {
          const capture: any = document.querySelector("#capture");
          html2canvas(capture, {
            useCORS: true, //（图片跨域相关）
            width: capture.clientWidth,
            height: capture.clientHeight,
            scrollX: 0,
            scrollY: 0
          })
            .then(canvas => {
              setTimeout(() => {
                this.$emit("getpic", canvas.toDataURL());
              });
            })
            .catch(err => {});
        }, 300);
      }
    }
  });
  